export default __webpack_public_path__ + "7da913316edb438e3236cf137f57bd5c.svg";